import { connect } from 'react-redux';

import {
  appModalClose,
  appModalOpen,
  filtersGetAll,
  systemGet,
  systemsGetAll,
} from 'actions';

import View from './';

const mapStateToProps = state => ({
  intl: state.intl,
  filters: state.filters.all,
  systems: state.systems.all,
});

const mapDispatchToProps = (dispatch) => {
  return {
    appModalClose(payload) {
      dispatch(appModalClose(payload));
    },
    appModalOpen(payload) {
      dispatch(appModalOpen(payload));
    },
    filtersGetAll(payload) {
      dispatch(filtersGetAll(payload));
    },
    systemGet(payload) {
      return dispatch(systemGet(payload));
    },
    systemsGetAll(...payload) {
      dispatch(systemsGetAll(...payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/overview/container.js